import React, { useState, memo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Es difícil de aprender?',
  a: 'No, son 3 pasos físicos simples diseñados para una mamá bajo estrés. No necesitas memorizar teorías complejas, solo saber dónde poner tus manos y qué palabra decir.'
}, {
  q: '¿Sirve para niños no verbales?',
  a: 'Sí, de hecho, funciona mejor con ellos porque se basa en el cuerpo, no en el lenguaje. La propiocepción es un lenguaje universal para el sistema nervioso.'
}, {
  q: '¿Tengo que comprar equipo caro?',
  a: "No, la mayoría de las herramientas ya las tienes en casa o cuestan menos de $10. El verdadero 'equipo' eres tú y tu capacidad de anclarlo."
}, {
  q: '¿Es un libro largo?',
  a: 'Es una guía operativa directa al grano, diseñada para leerse en una tarde. Sabemos que como mamá no tienes tiempo para relleno.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-white py-24 px-6" data-id="element-25">
      <div className="max-w-3xl mx-auto" data-id="element-26">
        <div className="text-center mb-12" data-id="element-27">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-4" data-id="element-28">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-29">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-xl overflow-hidden bg-cream/30" data-id="element-30">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-31">
                <span className="font-serif font-bold text-lg text-navy pr-4" data-id="element-32">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-copper transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-33" />
              </button>
              <AnimatePresence data-id="element-34">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-35">
                    <div className="p-6 pt-0 text-gray-600 leading-relaxed border-t border-gray-100" data-id="element-36">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}